import styled from "styled-components";

export const DownloadWrapper = styled.div`
  min-height: calc(100vh - 150px);
`;
